import React, { Component } from 'react'
import { withStyles } from '@material-ui/core'
import api from '../util/api_v5'
import { PdcLogoBaseIcon } from 'pdc-svg-icons'

const styles = theme => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        overflowY: 'auto',
        background: theme.palette.secondary['-500'],
        padding: 15
    },
    errorWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
    },
    logoWrapper: {
        '& svg': {
            width: 74,
            height: 74
        }
    },
    mainError: {
        fontSize: 24,
        fontWeight: 'bold',
        padding: '15px 0px'
    },
    secondaryError: {
        fontSize: 16,
        color: theme.palette.secondary[0],
        fontWeight: 'bold'
    }
})

class InviteHandler extends Component {
    constructor (props) {
        super(props)
        this.state = {
            loading: true,
            error: 'Invitation link expired'
        }
    }

    componentDidMount = async () => {
        const parsedQueryString = this.getJsonFromUrlQuery()
        const invite_hash = parsedQueryString.invite_hash
        if (invite_hash) {
            window.history.pushState({}, document.title, '/')
            const response = await api.verifyInviteToken(invite_hash)
            if (response.error) {
                this.setState({ loading: false, error: response.error })
            } else {
                window.location.replace(response.redirect_link)
            }
        } else {
            this.setState({ loading: false })
        }
    }

     getJsonFromUrlQuery = () => {
         const url = window.location.search
         const query = url.substr(1)
         const result = {}
         query.split('&').forEach(function (part) {
             const item = part.split('=')
             result[item[0]] = decodeURIComponent(item[1])
         })
         return result
     }

    renderLoadingView = () => {
        return (
            <div>
				Loading ...
            </div>
        )
    }

    renderErrorView = () => {
        const { classes } = this.props
        return (
            <div className={classes.errorWrapper}>
                <div className={classes.logoWrapper}>
                    <PdcLogoBaseIcon/>
                </div>
                <div className={classes.mainError}>
                    {this.state.error}
                </div>
                <div className={classes.secondaryError}>
                    Contact your Phone.com admin to get a new invite.
                </div>
            </div>
        )
    }

    render () {
        const { classes } = this.props
        return (
            <div className={classes.wrapper}>
                {this.state.loading ? this.renderLoadingView() : this.renderErrorView()}
            </div>
        )
    }
}

export default withStyles(styles)(InviteHandler)
